/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CountDealsRequest
 */
export interface CountDealsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CountDealsRequest
     */
    'dealStatusList'?: Array<CountDealsRequestDealStatusListEnum>;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'userAccountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'userAccountGroupId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'dealKeyword'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CountDealsRequest
     */
    'dealIds'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'yearMonth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'startDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'amountLowerLimit'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'amountUpperLimit'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CountDealsRequest
     */
    'qualifiedEvidence'?: CountDealsRequestQualifiedEvidenceEnum;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'accountItemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'taxCode'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'itemId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'sectionId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'tagId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CountDealsRequest
     */
    'partnerId'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CountDealsRequest
     */
    'canSync'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CountDealsRequest
     */
    'isInvalidTaxCode'?: boolean | null;
}

export const CountDealsRequestDealStatusListEnum = {
    notEntered: 'NOT_ENTERED',
    automaticJournalized: 'AUTOMATIC_JOURNALIZED',
    automaticIntegrated: 'AUTOMATIC_INTEGRATED',
    entering: 'ENTERING',
    journalized: 'JOURNALIZED',
    changedAfterJournalization: 'CHANGED_AFTER_JOURNALIZATION',
    integrated: 'INTEGRATED',
    changedAfterIntegration: 'CHANGED_AFTER_INTEGRATION',
    ignored: 'IGNORED',
    readyAutomaticIntegration: 'READY_AUTOMATIC_INTEGRATION'
} as const;

export type CountDealsRequestDealStatusListEnum = typeof CountDealsRequestDealStatusListEnum[keyof typeof CountDealsRequestDealStatusListEnum];
export const CountDealsRequestQualifiedEvidenceEnum = {
    allNotQualified: 'ALL_NOT_QUALIFIED',
    containQualified: 'CONTAIN_QUALIFIED'
} as const;

export type CountDealsRequestQualifiedEvidenceEnum = typeof CountDealsRequestQualifiedEvidenceEnum[keyof typeof CountDealsRequestQualifiedEvidenceEnum];


